module.exports = function() {
  return new Worker(__webpack_public_path__ + "101cedc1f8a1dd63ee1a.worker.js");
};